import BoldSmallText from '@/components/BoldSmallText';
import CustomCard from '@/components/customCard';
import IconButton from '@/components/IconButton';
import RegularText from '@/components/RegularText';
import { prefixIconColors, prefixIconSizes } from '@/constants';
import {
  PrefixIconColor,
  PrefixIconColorKeys,
  PrefixIcon as PrefixIconEnum,
  PrefixIconSize,
  PrefixIconSizeKeys,
} from '@/constants/enum';
import { prefixIcons } from '@/constants/icons';
import parse from 'html-react-parser';

interface IProps {
  isRequired?: boolean;
  iconSize: PrefixIconSizeKeys;
  iconColor: PrefixIconColorKeys;
  iconId: PrefixIconEnum;
  changeIcon: (value: PrefixIconEnum) => void;
  changeIconSize: (value: PrefixIconSize) => void;
  changeIconColor: (value: PrefixIconColor) => void;
  defaultOpen?: boolean;
}

export default function PrefixIcon(props: IProps) {
  return (
    <CustomCard required={props.isRequired} title="Prefix icon">
      <div className="mt-8">
        <RegularText>This will show to the left of message text</RegularText>
      </div>

      <div className="mt-8">
        <BoldSmallText>Icon</BoldSmallText>
      </div>
      <div className="mt-4 editor-icon-container" style={{ gap: '8px' }}>
        {prefixIcons.map((icon) => {
          if (icon.id === PrefixIconEnum.none) {
            return (
              <IconButton
                onClick={() => props.changeIcon(icon.id)}
                cursorPointer
                selected={props.iconId === icon.id}
                key={icon.id}
              >
                None
              </IconButton>
            );
          }
          return (
            <IconButton onClick={() => props.changeIcon(icon.id)} cursorPointer selected={props.iconId === icon.id} key={icon.id}>
              {parse(icon.icon({}))}
            </IconButton>
          );
        })}
      </div>

      {props.iconId !== PrefixIconEnum.none ? (
        <>
          <div className="mt-8">
            <BoldSmallText>Icon size</BoldSmallText>
          </div>
          <div className="mt-4 editor-icon-container" style={{ gap: '8px' }}>
            {Object.keys(PrefixIconSizeKeys).map((key) => (
              <div className="d-flex flex-column" key={key}>
                <IconButton
                  onClick={() => props.changeIconSize(key as PrefixIconSize)}
                  cursorPointer
                  selected={props.iconSize === key}
                >
                  {parse(
                    prefixIcons
                      .find((icon) => icon.id === PrefixIconEnum.truck)
                      ?.icon({ size: prefixIconSizes[key as keyof typeof PrefixIconSizeKeys] }) || '',
                  )}
                </IconButton>
                <div className="flex content-center">
                  <RegularText>{PrefixIconSize[key as keyof typeof PrefixIconSize]}</RegularText>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8">
            <BoldSmallText>Icon color</BoldSmallText>
          </div>
          <div className="mt-4 editor-icon-container" style={{ gap: '8px' }}>
            {Object.keys(PrefixIconColorKeys).map((key) => (
              <div className="d-flex flex-column" key={key}>
                <IconButton
                  onClick={() => props.changeIconColor(key as PrefixIconColor)}
                  cursorPointer
                  selected={props.iconColor === key}
                >
                  {parse(
                    prefixIcons
                      .find((icon) => icon.id === PrefixIconEnum.truck)
                      ?.icon({ color: prefixIconColors[key as keyof typeof PrefixIconColorKeys] }) || '',
                  )}
                </IconButton>
                <div className="flex content-center">
                  <RegularText>{PrefixIconColor[key as keyof typeof PrefixIconColor]}</RegularText>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : null}
    </CustomCard>
  );
}
